import { render, staticRenderFns } from "./occupation.vue?vue&type=template&id=bec34794&scoped=true"
import script from "./occupation.vue?vue&type=script&lang=js"
export * from "./occupation.vue?vue&type=script&lang=js"
import style0 from "./occupation.vue?vue&type=style&index=0&id=bec34794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec34794",
  null
  
)

export default component.exports